import React from "react";
import { LoginServices } from "../../services/LoginServices";
import { useNavigate } from "react-router-dom";
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';

const DropdownLogin = ({ open }) => {
  const navigate = useNavigate();

  const handleClickLogout = () => {
    LoginServices.logout();
  };

  const handleClickConfiguration = () => {
    navigate("/configuration");
  };

  return (
    <>
      <div className={`fixed -ml-56 md:ml-12 bottom-32 md:bottom-14 w-64 z-50 ${open ? "block" : "hidden"} `}>
        <ul className="absolute bg-white w-full shadow-lg rounded-md -bottom-12">
          <div>
            <li onClick={() => handleClickConfiguration()} className="flex flex-row cursor-pointer bg-white hover:bg-dark-primary hover:text-white p-2 select-none rounded-t-md">
              <SettingsIcon className="w-4 mr-2" />
              <p>Configurações</p>
            </li>
          </div>
          <div>
            <li onClick={handleClickLogout} className="flex flex-row cursor-pointer text-black hover:bg-rose-700 hover:text-white p-2 select-none rounded-b-md">
              <LogoutIcon className="w-4 mr-2" />
              <p className="w-4 ">Sair</p>
            </li>
          </div>
        </ul>
      </div>
    </>
  );
};
export default DropdownLogin;